export default __webpack_public_path__ + "static/ROC_solid_video_thumbnail2-ec0bdaa8bf611dea2d30deadeb610447.png";